import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fb07c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-container" }, " Udvalg ", -1))
const _hoisted_3 = { class: "sidebar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftSideBar = _resolveComponent("LeftSideBar")!
  const _component_front_sidebar = _resolveComponent("front-sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LeftSideBar),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_front_sidebar)
    ])
  ]))
}